import React from 'react'
import * as s from './style.module.sass'

export default ({ className, children }) => <div className={[s.content, className].join(' ')}>{children}</div>
